import { render, staticRenderFns } from "./popUp.vue?vue&type=template&id=90be6ab6&scoped=true&"
import script from "./popUp.vue?vue&type=script&lang=js&"
export * from "./popUp.vue?vue&type=script&lang=js&"
import style0 from "./popUp.vue?vue&type=style&index=0&id=90be6ab6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90be6ab6",
  null
  
)

export default component.exports